module.exports = __webpack_public_path__ + "static/assets/36cbec7c18e09b7d4e4c05cae3ae419c.png";